<template>
    <div class="space-y-4">
        <div>
            <p class="text-lg font-bold text-slate-900">Signature client</p>
        </div>

        <!-- Consentement -->
        <div class="flex items-start gap-3 bg-blue-50 border border-blue-100 rounded-2xl px-4 py-3">
            <svg class="w-4 h-4 text-blue-600 mt-0.5 shrink-0" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/></svg>
            <p class="text-xs text-blue-700 leading-relaxed">
                En signant, le client confirme la bonne réalisation de l'intervention et consent à la collecte de ses données pour les documents associés.
            </p>
        </div>

        <!-- Canvas signature -->
        <div class="bg-white rounded-2xl border-2 border-dashed border-gray-300 overflow-hidden">
            <canvas
                ref="canvas"
                class="w-full touch-none block"
                style="height: 200px;"
                @mousedown="startDraw"
                @mousemove="draw"
                @mouseup="stopDraw"
                @mouseleave="stopDraw"
                @touchstart.prevent="startDrawTouch"
                @touchmove.prevent="drawTouch"
                @touchend="stopDraw"
            />
        </div>

        <!-- Actions -->
        <div class="flex gap-3">
            <button
                class="flex-1 py-3 border border-gray-200 rounded-xl text-slate-600 text-sm font-semibold hover:bg-gray-50 transition-colors"
                @click="clearCanvas"
            >
                <i class="fas fa-eraser"></i> Effacer
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StepSignature',
    inject: ['wm'],

    data() {
        return {
            _drawing: false,
            _ctx: null,
            hasSigned: false,
        };
    },

    mounted() {
        this.initCanvas();
        // Pré-charger la signature existante
        const existing = this.wm.formData.signatureClientLocal ?? this.wm.formData.signature_client;
        if (existing) {
            const img = new Image();
            img.onload = () => { this._ctx?.drawImage(img, 0, 0); };
            img.src = existing;
            this.hasSigned = true;
        }
    },

    methods: {
        initCanvas() {
            const canvas = this.$refs.canvas;
            if (!canvas) return;
            canvas.width  = canvas.offsetWidth;
            canvas.height = canvas.offsetHeight;
            this._ctx = canvas.getContext('2d');
            this._ctx.strokeStyle = '#1e293b';
            this._ctx.lineWidth   = 2.5;
            this._ctx.lineCap     = 'round';
            this._ctx.lineJoin    = 'round';
        },

        startDraw(e) {
            this._drawing = true;
            this._ctx?.beginPath();
            this._ctx?.moveTo(e.offsetX, e.offsetY);
        },
        draw(e) {
            if (!this._drawing || !this._ctx) return;
            this._ctx.lineTo(e.offsetX, e.offsetY);
            this._ctx.stroke();
            this.captureSignature();
        },
        stopDraw() { this._drawing = false; },

        startDrawTouch(e) {
            const rect = this.$refs.canvas.getBoundingClientRect();
            const t = e.touches[0];
            this._drawing = true;
            this._ctx?.beginPath();
            this._ctx?.moveTo(t.clientX - rect.left, t.clientY - rect.top);
        },
        drawTouch(e) {
            if (!this._drawing || !this._ctx) return;
            const rect = this.$refs.canvas.getBoundingClientRect();
            const t = e.touches[0];
            this._ctx.lineTo(t.clientX - rect.left, t.clientY - rect.top);
            this._ctx.stroke();
            this.captureSignature();
        },

        captureSignature() {
            const dataUrl = this.$refs.canvas?.toDataURL('image/png');
            if (!dataUrl) return;
            this.hasSigned = true;
            this.wm.updateFormData({ signatureClientLocal: dataUrl, signature_client: null });
        },

        clearCanvas() {
            const canvas = this.$refs.canvas;
            if (canvas && this._ctx) this._ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.hasSigned = false;
            this.wm.updateFormData({ signatureClientLocal: null, signature_client: null });
        },
    },
};
</script>
